import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialSummary = ({ language, summary }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat(language === 'ar' ? 'ar-MA' : 'fr-MA', {
      style: 'currency',
      currency: 'MAD'
    })?.format(amount);
  };

  const labels = {
    totalRevenue: language === 'fr' ? 'Revenu total' : language === 'ar' ? 'إجمالي الإيرادات' : 'Total Revenue',
    collected: language === 'fr' ? 'Encaissé' : language === 'ar' ? 'المحصل' : 'Collected',
    pending: language === 'fr' ? 'En attente' : language === 'ar' ? 'قيد الانتظار' : 'Pending',
    overdue: language === 'fr' ? 'En retard' : language === 'ar' ? 'متأخر' : 'Overdue'
  };

  const summaryCards = [
    {
      label: labels?.totalRevenue,
      amount: summary?.totalRevenue,
      icon: 'TrendingUp',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: labels?.collected,
      amount: summary?.collected,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: labels?.pending,
      amount: summary?.pending,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: labels?.overdue,
      amount: summary?.overdue,
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4 md:mb-6">
      {summaryCards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 md:p-6">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-1">{card?.label}</p>
          <p className={`text-xl md:text-2xl font-bold ${card?.color} monospace`}>
            {formatAmount(card?.amount)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default FinancialSummary;